<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M15.31 11.37a.894.894 0 0 1 0 1.263l-5.356 5.355a.894.894 0 0 1-1.263-1.263L13.416 12 8.693 7.275a.894.894 0 0 1 1.264-1.264l5.355 5.356z"/></svg>
</template>